{
  const BaseModule = require('_base/base')
  const SMALL_WIDTH = 500
  const CLASS_SMALL_PLAY = 'is__small'

  class VideoPlay extends BaseModule {
    postInit() {
      this.$videoPlay = this.$el.find('.video-play')
    }

    postCalculate() {
      this.wrapperWidth = Math.ceil(this.$el.width())
    }

    preRender() {
      this.$videoPlay.toggleClass(CLASS_SMALL_PLAY, this.wrapperWidth < SMALL_WIDTH)
    }
  }

  $('.js__video, .js__youtubeVideoCover').each(function() {
    new VideoPlay($(this))
  })
}
